// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__lTrTH","name":"ConsentHeader_name__1tQjd","birthday":"ConsentHeader_birthday__2FL6n","skeleton":"ConsentHeader_skeleton__2Wq-W"};